import React, { useState } from 'react';
import { Grid, Stack } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import {
  CardOptionTypography,
  CardOptionDescriptionTypography,
} from 'components/styles_components/typography';
import { setAuthenticated } from 'utils/authentication';
import LoginMutation from 'mutations/user/login';
import LoginForm from 'components/user/authorization/login_form';
import TwoFactorVerification from 'components/user/authorization/two_factor_verification';
import { DividerContainer } from 'components/styles_components/container';

const Login = () => {
  const intl = useIntl();
  const [step, setStep] = useState(0);

  const [loginMutation, { loading }] = useMutation(LoginMutation, {
    onCompleted: ({ login }) => {
      if (login.twoFactor) {
        setStep(1);
      } else {
        setAuthenticated(login.expiresIn);
      }
    },
  });

  const form = () => {
    if (step === 0) {
      return (
        <LoginForm
          initialValues={{
            email: '',
            password: '',
          }}
          onSubmit={(values, { setFieldError }) => {
            loginMutation({ variables: values }).catch(() => {
              setFieldError('password', intl.formatMessage({ id: 'error.user.login' }));
            });
          }}
          processing={loading}
        />
      );
    } else {
      return <TwoFactorVerification />;
    }
  };

  return (
    <Stack>
      <CardOptionTypography variant="h5" align="left">
        <FormattedMessage id="header.user.login" />
      </CardOptionTypography>
      <CardOptionDescriptionTypography>
        <FormattedMessage id="auth.login.description" />
      </CardOptionDescriptionTypography>
      <DividerContainer />
      <Grid container direction="row" justifyContent="center" alignItems="center">
        {form()}
      </Grid>
    </Stack>
  );
};

export default Login;
